import { render, staticRenderFns } from "./VStatusBadget.vue?vue&type=template&id=dbc0bb56&"
import script from "./VStatusBadget.vue?vue&type=script&lang=ts&"
export * from "./VStatusBadget.vue?vue&type=script&lang=ts&"
import style0 from "./VStatusBadget.vue?vue&type=style&index=0&id=dbc0bb56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports